<br /><br /><br /><br />
<div class="page-title">
  <h1 class="title-text">Field Book Number Request</h1>
  <p class="form-desc"></p>
</div>
<br />

<mat-card class="mat-mdc-elevation-specific mat-elevation-z8">
  <mat-card-content>

    <div class="sections">
      <mat-panel-title class="section-title">
        Field Book Number Request
      </mat-panel-title>
      <br /><br /><br />

      <form [formGroup]="form" (ngSubmit)="getFieldBookNumber()">
        <!-- <div formGroupName="fieldBookRequest"> -->

        <!-- Read-Only Mode -->
        @if (requestSubmitted) {
          <p><span style="color: gray">Your Email:</span> {{ form.value.requestorEmail }} </p>
          <p><span style="color: gray">Office where field book will be stored:</span> {{ form.value.officeName }} </p>
          <br />
          <p style="font-size: 20px;">Field Book Number:</p><p style="font-size: 30px; color: #d0511d;">{{ fieldBookNumber }}</p>
        } @else {
          <mat-form-field appearance="fill">
            <mat-label>Your Email:</mat-label>
            <input matInput placeholder="Enter email" formControlName="requestorEmail" required/>
          </mat-form-field>
          <br /><br />
          <mat-form-field appearance="fill">
            <mat-label>Office where field book will be stored:</mat-label>
            <mat-select formControlName="officeName" required>
              <mat-option value="Houston">Houston</mat-option>
              <mat-option value="Ft. Worth">Ft. Worth</mat-option>
              <mat-option value="Irving">Irving</mat-option>
              <mat-option value="Magnolia">Magnolia</mat-option>
              <mat-option value="Windsor">Windsor</mat-option>
              <mat-option value="Midland">Midland</mat-option>
              <mat-option value="Phoenix">Phoenix</mat-option>
            </mat-select>
          </mat-form-field>
          <div class="button-container">
            <button mat-raised-button color="primary" class="submit-button" [disabled]="loadingForm">Request Field Book Number</button>
          </div>
          @if (loadingForm) {
            <div class="loading-spinner">
              <mat-spinner diameter="30"></mat-spinner>
            </div>
          }
          @if (!loadingForm && form.invalid && form.touched) {
            <div class="error-message">
              Please fill in all required fields.
            </div>
          }
        }

        <!-- Editable Mode -->
      </form>
    </div>

  </mat-card-content>
</mat-card>
<br><br>

<div class="page-title">
  <p class="form-desc-two">If form does not submit, ensure all required fields are answered. Additionally, depending on the network, the form submission may take a minute. If it still does not submit, reach out directly to <i class="contact">(pturner&#64;landpoint.net)</i> to get it handled. </p>
</div>
